import { TreeSelectProps } from 'antd/lib';

import { AggregatedProductIdentity } from 'codegen';
import { TFieldProps } from 'types';

export const fields = ({ retailers, isTypeAI }: { isTypeAI: boolean; retailers: TreeSelectProps['treeData'] }): TFieldProps[] => [{
  type: TFieldProps.type.Select,
  name: 'type',
  label: 'Type',
  options: Object.values(AggregatedProductIdentity.type).map((type) => ({ label: type, value: type })),
  allowClear: false,
  rules: [{
    message: 'Required',
    required: true,
  }],
}, {
  type: TFieldProps.type.Text,
  width: 80,
  label: 'Value',
  name: 'value',
  rules: [{
    message: 'Required',
    required: true,
  }],
}, {
  type: TFieldProps.type.TreeSelect,
  width: 300,
  label: 'Retailers',
  name: 'retailers',
  treeData: retailers,
  rules: [{
    message: 'Required',
    required: true,
  }],
}, {
  type: TFieldProps.type.Percent,
  name: 'partialMatchThreshold',
  label: 'Partial Match Threshold',
  placeholder: isTypeAI ? 'AUTO' : '',
  disabled: isTypeAI,
  rules: isTypeAI ? [] : [{
    message: 'Required',
    required: true,
  }],
}, {
  type: TFieldProps.type.Percent,
  name: 'fullMatchThreshold',
  label: 'Full Match Threshold',
  placeholder: isTypeAI ? 'AUTO' : '',
  disabled: isTypeAI,
  rules: isTypeAI ? [] : [{
    message: 'Required',
    required: true,
  }],
}];
